import styled, { css } from "styled-components";
export var RadioGroupWrapper = /*#__PURE__*/ styled.div.withConfig({
  displayName: "RadioGroupstyle__RadioGroupWrapper"
})(() => css(["display:flex;flex-direction:column;justify-content:space-between;"]));
